<template>
  <h2>This will be the time-line page</h2>
</template>

<script>
/** This component handles the sign-up/register page
 * @memberOf Static
 * @name Timeline
 * @type module
 * @instance
 * */
export default {
  name: "Timeline",
};
</script>

<style scoped></style>
